// Room service for room management APIs

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.sortmyspot.com/';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

// List rooms with filters (for a specific hotel)
export const listRooms = async (filters = {}) => {
  try {
    const response = await fetch(`${API_BASE_URL}/web/room/list`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        q: filters.query || {},
        p: filters.project || {},
        s: filters.sort || { createdAt: -1 },
        o: filters.skip || 0,
        l: filters.limit || 10,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch rooms');
    }

    return data;
  } catch (error) {
    console.error('List rooms error:', error);
    throw error;
  }
};

// Get single room by ID
export const getRoom = async (roomId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/room/${roomId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to fetch room');
    }

    return data;
  } catch (error) {
    console.error('Get room error:', error);
    throw error;
  }
};

// Create new room
export const createRoom = async (roomData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/room/`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(roomData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to create room');
    }

    return data;
  } catch (error) {
    console.error('Create room error:', error);
    throw error;
  }
};

// Update room
export const updateRoom = async (roomId, roomData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/room/${roomId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(roomData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to update room');
    }

    return data;
  } catch (error) {
    console.error('Update room error:', error);
    throw error;
  }
};

// Delete room
export const deleteRoom = async (roomId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/panel/room/${roomId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to delete room');
    }

    return data;
  } catch (error) {
    console.error('Delete room error:', error);
    throw error;
  }
};

// Upload room images
export const uploadRoomImages = async (files) => {
  try {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('room', file);
    });

    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/panel/room/upload`, {
      method: 'POST',
      headers: {
        ...(token && { 'Authorization': `Bearer ${token}` }),
      },
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to upload room images');
    }

    return data;
  } catch (error) {
    console.error('Upload room images error:', error);
    throw error;
  }
};

// Remove image from S3
export const removeImage = async (filePath) => {
  try {
    const token = localStorage.getItem('authToken');
    const response = await fetch(`${API_BASE_URL}/panel/hotel/removeImage`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
      },
      body: JSON.stringify({ filePath }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to remove image');
    }

    return data;
  } catch (error) {
    console.error('Remove image error:', error);
    throw error;
  }
};
